import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { registerApiFallback } from './apiTranslation';
import {
  DEFAULT_LANGUAGE,
  LANGUAGE_COOKIE_MAX_AGE_SECONDS,
  LANGUAGE_STORAGE_KEY,
  LanguageCode,
  SUPPORTED_LANGUAGE_CODES,
  isSupportedLanguage,
  languageApiEnabled,
} from './config';
import as from './locales/as.json';
import en from './locales/en.json';
import gu from './locales/gu.json';
import hi from './locales/hi.json';

const getCookie = (name: string): string | null => {
  try {
    const match = document.cookie
      .split('; ')
      .find((row) => row.startsWith(`${name}=`));
    return match ? decodeURIComponent(match.split('=').slice(1).join('=')) : null;
  } catch {
    return null;
  }
};

const setCookie = (name: string, value: string, maxAgeSeconds: number) => {
  try {
    document.cookie = `${name}=${encodeURIComponent(
      value
    )}; path=/; max-age=${maxAgeSeconds}; SameSite=Lax`;
  } catch {
    /* cookies may be unavailable */
  }
};

const getInitialLanguage = (): LanguageCode => {
  try {
    const fromCookie = getCookie(LANGUAGE_STORAGE_KEY);
    if (isSupportedLanguage(fromCookie)) return fromCookie;
  } catch {
    /* cookies may be unavailable */
  }
  return DEFAULT_LANGUAGE;
};

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    hi: { translation: hi },
    as: { translation: as },
    gu: { translation: gu },
  },
  lng: getInitialLanguage(),
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: SUPPORTED_LANGUAGE_CODES,
  returnEmptyString: false,
  saveMissing: languageApiEnabled,
  interpolation: {
    escapeValue: false,
    prefix: '{',
    suffix: '}',
  },
  react: {
    useSuspense: false,
    bindI18n: 'languageChanged loaded added removed',
  },
});

if (languageApiEnabled) {
  registerApiFallback(i18n);
}

export const changeAppLanguage = (lng: LanguageCode) => {
  setCookie(LANGUAGE_STORAGE_KEY, lng, LANGUAGE_COOKIE_MAX_AGE_SECONDS);
  return i18n.changeLanguage(lng);
};

export default i18n;
